// extracted by mini-css-extract-plugin
module.exports = {"WarningIcon":"WarningBadge_WarningIcon__sN1mj","badge":"WarningBadge_badge__qB476"};